import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from "chart.js";
import { generateRandomArray, labels, options } from "./barChartOptions";
import { MultiBarChartProp } from "../../../../@types/charts/mutiBarCharts.types";

const MultiBarChart: React.FC<MultiBarChartProp> = ({ multiBarChartData }) => {
	const [chartDate, setChartData] = useState<any>({
		labels,
		datasets: [
			{
				label: "ACTIVE",
				data: generateRandomArray(),
				backgroundColor: "#006A71"
			},
			{
				label: "HIRE",
				data: generateRandomArray(),
				backgroundColor: "#75B79E"
			}
		]
	});

	ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

	useEffect(() => {
		const { currentActive, currentHire } = multiBarChartData;
		const updatedChartDatas = {
			labels,
			datasets: [
				{
					label: "ACTIVE",
					data: currentActive,
					backgroundColor: "#006A71"
				},
				{
					label: "HIRE",
					data: currentHire,
					backgroundColor: "#75B79E"
				}
			]
		};
		setChartData(updatedChartDatas);
	}, [multiBarChartData]);

	return <Bar options={options} data={chartDate} style={{ maxHeight: "23rem" }} />;
};

export default MultiBarChart;
